import NotFound from 'pages/404'
import Home from 'pages/Home'
import Login from 'pages/Login'
import Profile from 'pages/Profile'
import Registry from 'pages/Registry'
import EventDetail from 'pages/Event/Detail'
import EventGame from 'pages/Event/Game'

interface Props {
  path: string
  element: () => JSX.Element | null
}

export const publicRoutes: Props[] = []

export const authRoutes: Props[] = [
  {
    path: '/login',
    element: Login,
  },
  {
    path: '/register',
    element: Registry,
  },
]

export const privateRoutes: Props[] = [
  {
    path: '/',
    element: Home,
  },
  {
    path: '/event/:id/game',
    element: EventGame,
  },
  {
    path: '/event/:id',
    element: EventDetail,
  },
  {
    path: '/profile',
    element: Profile,
  },
  {
    path: '*',
    element: NotFound,
  },
]
